// import { actionTypes } from "./types";
import { actionTypes } from "../language/types";

export const changeLangAction = (language: string, langKey: string) => ({
    type: actionTypes.CHANGE_LANG,
    payload: { language, langKey }
});